import { customizeProductPages } from './landingPages'
import { getBrandImagePresentation } from './brandScenes'
import googleMerchant from './googleMerchant.json'

const config = {

  customizeProductPages,
  pageBuilderImagePresentation: getBrandImagePresentation,
  hideAiGeneratedBadges: true,
  spaciousBrandCarousels: true,

  // Warenkorb je Shop: 'classic' = bisherige Ansicht, 'modern' = kompakte Ansicht.
  cartVariant: 'modern',
  mobileMenuVariant: 'modern',
  checkoutVariant: 'modern',
  compactCheckoutFooter: true,
  productStickyPurchase: true,
  footerMobileAccordions: true,

  deliveryCountries: ['DE'],

  googleMerchant,

  // Template-Elemente
  productLagerwareTopAlert: true,
  stockDeliveryTime: 3,
  couponDisplay:true,
  VorkasseDisplay:true,
  NachnahmeDisplay:false,
  RechnungDisplay:false,
  PayPalAdvancedCardsDisplay:true,
  PayPalGooglePayDisplay:true,
  // Apple Pay ist fuer liebeszuhause aktuell nur mit paypal@homeylove.de nutzbar.
  // Bei info@homeylove.de auf false lassen; bei paypal@homeylove.de wieder true setzen.
  PayPalApplePayDisplay:false,
  PayPalPayLaterDisplay:true,

  // Strukturierte Daten: Standardwerte je Shop vor Launch pruefen.
  structuredData: {
    returns: {
      merchantReturnDays: 14,
      returnFees: 'https://schema.org/ReturnFeesCustomerResponsibility',
      returnMethod: 'https://schema.org/ReturnByMail',
      refundType: 'https://schema.org/FullRefund',
      applicableCountries: ['DE'],
      returnPolicyCountry: 'DE',
    },
    shipping: {
      destinationCountry: 'DE',
      handlingTime: { minValue: 0, maxValue: 1, unitCode: 'DAY' },
      shippingTypes: {
        1: { name: 'Warenpost', rate: 'deutschland' },
        10: { name: 'Paket-Versand', rate: 'deutschland' },
        12: { name: 'Paket-Versand Sperrgut', rate: 'deutschland' },
        20: { name: 'Speditions-Versand', rate: 'spedition' },
        30: { name: 'Speditions-Versand Sperrgut', rate: 'spedition' },
      },
      defaultShippingType: 10,
    },
  },

  pageBuilderDefaults: {
    layout: {
      stylePreset: 'westwing',
      navigationPosition: 'top',
      navigationDisplay: 'inline',
      heroMobileMode: 'fullscreen',
      contentWidth: 'full',
      magazinePlacement: 'hidden',
      hideLegacyHeader: true,
      showCategorySliderArrows: true,
    },
    theme: {
      fontFamily: '"DM Sans", Arial, sans-serif',
      backgroundColor: '#ffffff',
      surfaceColor: '#f3f0ed',
      textColor: '#1f1a17',
      mutedTextColor: '#706760',
      accentColor: '#ba0063',
      accentContrastColor: '#ffffff',
      buttonBackgroundColor: '#ba0063',
      buttonHoverColor: '#970050',
      buttonTextColor: '#ffffff',
      purchaseButtonBackgroundColor: '#ba0063',
      purchaseButtonHoverColor: '#970050',
      purchaseButtonTextColor: '#ffffff',
      infoColor: '#3b6d8f',
      successColor: '#1f7a4d',
      warningColor: '#b7791f',
      errorColor: '#b8463f',
      navigationBackgroundColor: '#ffffff',
      navigationTextColor: '#1f1a17',
      navigationOverlayOpacity: 22,
    },
    products: {
      columnsPerRow: 4,
      columnsPerRowMobile: 2,
    },
  },

  headerLogo: {
    // Tight wordmark framing enlarges mobile; retain the desktop's visible width.
    builderMaxWidth: 297.5,
    builderMaxHeight: 68,
    builderInlineMaxWidth: 360,
    builderMobileMaxWidth: 'clamp(224px, 72vw, 330px)',
    builderMobileMaxHeight: 82,
  },

  productPreview: {
    mobileStyle: 'editorial',
  },

  productImageViewer: {
    variant: 'fullscreen',
  },

  // PayPal
  paypal: {
    live: {
      //für info@homeylove.de:
      "client-id": 'Aa4vq3TNbFEXQPdVY0SuBYsV6L92as8nuFKlKtCDqNUZwRlLgJSmxCQoSVkycKwYQC85ytZuVTd12eyK',
      
      //für paypal@homeylove.de:
      //"client-id": 'AXFT046jeEqRBMjCrm_0ChBrOlGx5OMF2tX5U_lbZyxIqr6SUVlHibk_Ov2Hdor7bQop9G3dLbHNUYDj',
    },
    dev: {
      "client-id": 'AXNo2j0t33R20Sdp5bu9ZzbMsyVMSpLoxqPozCky0t6GRRmo3YbCA3PPpFmmKNzMMDD1amQ96etxkoDA',
      //"data-client-token": "abc123xyz==",
    },
  },

  // Footer
  brands: [

    36,  // Joop!
    39,  // Cawoe
    166, // Greengate
    200, // Vossen

    //42,  // Bassetti
    //34,  // Formesse
    160, // The Laundress
    189, // Bondi Wash

    203, // Meraki
    201, // Claus Porto
    190, // Björk & Berries
    196, // Le Jacquard Francais
    
  ]

} as const

export default config
